import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class BrowserHelper {

    constructor() {
    }

    openUrl(path, target = '_blank', options = 'enableViewportScale=yes,location=no') {
        // Log.debug('=== Opening link from browser-helper.openUrl: ', path);


        // Add http:// if the url is missing it
        if (!path.toLowerCase().startsWith('http')) {
            path = 'https://' + path;
        }

        // Log.debug('   open with: window.open(' + path + ', ' + target + ');');
        return window.open(path, target);
    }

    openUrlInSystem(path, target = '_blank') {
        const cleanPath = encodeURI(path);
        // Log.debug('=== Opening link in system: ', cleanPath);
        return window.open(cleanPath, target);
    }
}
